// extracted by mini-css-extract-plugin
var _1 = "MCCR9";
var _2 = "NtWVO";
var _3 = "_j20v";
var _4 = "ZeJG7";
var _5 = "MOp66";
var _6 = "hlSyl";
var _7 = "QBhG6";
var _8 = "_qm6D";
var _9 = "esG11";
var _a = "a5Vlh";
var _b = "P3Qae";
var _c = "s4riJ";
var _d = "ZNfNy";
var _e = "RA0Rx";
var _f = "HlpLu";
var _10 = "s8bxe";
var _11 = "RvctH";
var _12 = "mrpl5";
var _13 = "ItQmM";
var _14 = "F8x9F";
var _15 = "PCBUs";
export { _1 as "column", _2 as "column-mapping", _3 as "column-mapping-left", _4 as "column-mapping-right", _5 as "columnButton", _6 as "combineMode", _7 as "conditionButton", _8 as "dataTypeIcon", _9 as "details", _a as "double", _b as "draft", _c as "helpText", _d as "historyButtons", _e as "icon", _f as "materialization", _10 as "openInSql", _11 as "settings", _12 as "source", _13 as "sql", _14 as "table", _15 as "title" }
